import { FcGoogle } from "react-icons/fc";
import { MdMailOutline } from "react-icons/md";
import logo from "../../../assets/images/logo.svg";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { authApi, BASE_URL } from "../../../api/api";
import { toast } from "react-toastify";

const LoginForm = () => {
  const [loginByEmailFlag, setLoginByEmailFlag] = useState(false);
  const [isLoginFlag, setIsLoginFlag] = useState(true);
  const [inputEmail, setInputEmail] = useState("sia@cfbtel.com");
  const [inputPassword, setInputPassword] = useState("Sia$123456");
  const [confirmPassword, setConfirmPassword] = useState("Sia$123456");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showSignupDialog, setShowSignupDialog] = useState(false);
  const navigate = useNavigate();

  const handleGoogleLogin = () => {
    const url = `${BASE_URL}/auth/social/google?user_group=business`;
    console.log("handleGoogleLogin:: ", url);
    window.open(url, "_self");
  };

  const handleEmailLoginFlag = () => {
    setLoginByEmailFlag(true);
  };

  const handleLoginByEmail = async (email: string, password: string) => {
    console.log("handleLoginByEmail:: ", email, password);
    try {
      const response = await authApi.loginByEmailPassword(email, password);
      console.log("login response", response);
      if (response.status === 200) {
        navigate("/otp", { state: { email, password } });
      }
      console.log(response);
    } catch (error) {
      console.error("email login error", error);
    }
  };

  const handleSignupByEmail = async (
    email: string,
    password: string,
    confirmPassword: string
  ) => {
    if (password !== confirmPassword) {
      alert("Passwords do not match");
      return;
    }
    try {
      const response = await authApi.registerByEmailPassword(
        email,
        password,
        confirmPassword
      );
      console.log("signup response", response, response.data, response.status);
      if (response.status === 200) {
        // Clear input fields
        setInputEmail("");
        setInputPassword("");
        setConfirmPassword("");
        // Show success dialog
        setShowSignupDialog(true);
      }
    } catch (error) {
      console.error("signup error", error);
      toast.error("Signup failed: " + error);
    }
  };

  return (
    <div className="w-full max-w-[400px] flex flex-col items-center py-10">
      {/* Logo */}
      <div className="mb-8">
        <img src={logo} alt="Logo" className="h-10" />
      </div>

      {/* Login text */}
      {isLoginFlag ? (
        <h1 className="text-2xl font-semibold mb-8">Log in</h1>
      ) : (
        <h1 className="text-2xl font-semibold mb-8">Sign up</h1>
      )}

      <button
        onClick={handleGoogleLogin}
        className="flex items-center justify-center w-full py-3 px-4 mb-4 border border-gray-200 rounded-lg hover:bg-gray-50"
      >
        <FcGoogle className="text-xl mr-2" />
        Continue with Google
      </button>

      {!loginByEmailFlag ? (
        <button
          onClick={handleEmailLoginFlag}
          className="flex items-center justify-center w-full py-3 px-4 mb-8 border border-gray-200 rounded-lg hover:bg-gray-50"
        >
          <MdMailOutline className="text-xl mr-2" />
          Continue with email
        </button>
      ) : (
        <div className="w-full flex flex-col gap-4 items-center">
          <input
            type="email"
            placeholder="Email"
            className="w-full border border-gray-200 rounded-lg p-2"
            value={inputEmail}
            onChange={(e) => setInputEmail(e.target.value)}
          />
          <div className="relative w-full">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              className="w-full border border-gray-200 rounded-lg p-2 pr-10"
              value={inputPassword}
              onChange={(e) => setInputPassword(e.target.value)}
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
            >
              {showPassword ? (
                <AiOutlineEyeInvisible className="text-xl" />
              ) : (
                <AiOutlineEye className="text-xl" />
              )}
            </button>
          </div>
          {!isLoginFlag ? (
            <div className="relative w-full">
              <input
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                type={showConfirmPassword ? "text" : "password"}
                name="confirmPassword"
                id="confirmPassword"
                placeholder="Confirm Password"
                className="w-full border border-gray-200 rounded-lg p-2 pr-10"
              />
              <button
                type="button"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
              >
                {showConfirmPassword ? (
                  <AiOutlineEyeInvisible className="text-xl" />
                ) : (
                  <AiOutlineEye className="text-xl" />
                )}
              </button>
            </div>
          ) : null}
          {!isLoginFlag ? (
            <button
              onClick={() =>
                handleSignupByEmail(inputEmail, inputPassword, confirmPassword)
              }
              className="w-full bg-green-500 text-white py-3 px-4 rounded-lg"
            >
              Sign up
            </button>
          ) : (
            <button
              onClick={() => handleLoginByEmail(inputEmail, inputPassword)}
              className="w-full bg-green-500 text-white py-3 px-4 rounded-lg"
            >
              Login
            </button>
          )}
        </div>
      )}

      {/* Sign up link */}
      <div className="text-sm text-gray-600">
        {isLoginFlag ? (
          <>
            Don't you have an account?{" "}
            <button
              onClick={() => setIsLoginFlag(false)}
              className="text-green-600 hover:underline"
            >
              Sign up
            </button>
          </>
        ) : (
          <>
            Already have an account?{" "}
            <button
              onClick={() => setIsLoginFlag(true)}
              className="text-green-600 hover:underline"
            >
              Log in
            </button>
          </>
        )}
      </div>

      {/* Signup Success Dialog */}
      {showSignupDialog && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-md mx-4 shadow-lg">
            <div className="text-center">
              <div className="mb-4">
                <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
                  <svg
                    className="h-6 w-6 text-green-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                </div>
              </div>
              <h3 className="text-lg font-medium text-gray-900 mb-2">
                Signup Successful!
              </h3>
              <p className="text-sm text-gray-600 mb-6">
                Please check your email for verification instructions. If you
                didn't get the email, please check your spam. If there was no
                email there too, make sure you are using the correct
                already-registered email.
              </p>
              <button
                onClick={() => setShowSignupDialog(false)}
                className="w-full bg-green-500 text-white py-2 px-4 rounded-lg hover:bg-green-600 transition-colors"
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LoginForm;
